// Exporta un visual (SVG real o un bloque HTML con estilos inline) a PNG/JPG.
// Puerto de descargarImg()/bajarDataURL() del mockup de referencia
// (sustemia_objetivos_matriz_estrategia.html) — 100% Web APIs nativas
// (XMLSerializer, Image, <canvas>), sin dependencias externas.
//
// Simplificación consciente respecto al mockup: acá no hace falta resolver
// var(--xxx) de CSS (cssVarsResueltas del mockup) porque los visuales de este
// proyecto usan colores hex directos en `style={{...}}`, no custom properties
// de :root.

function downloadDataUrl(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function rasterize(xml, canvasWidth, canvasHeight, mime, onDone, onError) {
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    onDone(canvas.toDataURL(mime, 0.92));
  };
  img.onerror = onError;
  img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);
}

// wrapEl: nodo DOM real (ref.current) que contiene el visual — un <svg> real
// (rueda) o un bloque HTML con estilos inline (Gantt, etc.).
export function exportVisualImage(wrapEl, format, name) {
  if (!wrapEl) return;
  const filename = `sustemia_${name}_${new Date().toISOString().slice(0, 10)}.${format}`;
  const mime = format === "jpg" ? "image/jpeg" : "image/png";
  const onError = () => window.alert("No se pudo generar la imagen. Probá con Descargar PDF.");

  const svg = wrapEl.querySelector("svg");
  if (svg) {
    // Ruta dedicada para SVG real: nítido a resolución fija 1240×1240.
    const xml = new XMLSerializer().serializeToString(svg);
    rasterize(xml, 1240, 1240, mime, (dataUrl) => downloadDataUrl(dataUrl, filename), onError);
    return;
  }

  // Visuales HTML (Gantt, etc.): se envuelve todo el bloque en un
  // <svg><foreignObject> sintético y se rasteriza a 2x el tamaño en pantalla.
  const rect = wrapEl.getBoundingClientRect();
  const w = Math.ceil(rect.width);
  const h = Math.ceil(rect.height);
  const inner = new XMLSerializer().serializeToString(wrapEl);
  const xml = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><foreignObject width="100%" height="100%"><div xmlns="http://www.w3.org/1999/xhtml" style="width:${w}px;font-family:Arial,Helvetica,sans-serif;background:#fff">${inner}</div></foreignObject></svg>`;
  rasterize(xml, w * 2, h * 2, mime, (dataUrl) => downloadDataUrl(dataUrl, filename), onError);
}
